import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-lg-4" }

import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import { tablePageSizeOptions, URL_QUERY } from '@/views/community-admin/community-site/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  pageSize: {
    type: Number,
    default: 0,
  },
  numberOfPages: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Pagination, {
      totalPage: __props.numberOfPages,
      totalDataOfPage: __props.pageSize
    }, null, 8, ["totalPage", "totalDataOfPage"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SelectCustom, {
        options: _unref(tablePageSizeOptions),
        keyName: _unref(URL_QUERY).PAGE_SIZE
      }, null, 8, ["options", "keyName"])
    ])
  ]))
}
}

})